<template>
  <div class="order-detail">

    <!-- 交易信息 -->
    <el-card shadow="hover" class="detail-card">
      <div slot="header">
        <span>交易信息</span>
      </div>

      <el-row :gutter="20">

        <el-col :span="12">
          <div class="detail-item">
            <label>流水订单号</label>
            <span>{{ detail.trNo }}</span>
          </div>
        </el-col>

        <el-col :span="12">
          <div class="detail-item">
            <label>商户订单号</label>
            <span>{{ detail.trMerOrderno }}</span>
          </div>
        </el-col>

        <el-col :span="12">
          <div class="detail-item">
            <label>网关流水号</label>
            <span>{{ detail.trgwno }}</span>
          </div>
        </el-col>

        <el-col :span="12">
          <div class="detail-item">
            <label>交易时间</label>
            <span>{{ detail.tradeDatetime }}</span>
          </div>
        </el-col>

        <el-col :span="12">
          <div class="detail-item">
            <label>交易金额</label>
            <span>
              {{ detail.currency }}
              {{ detail.trAmout }}
            </span>
          </div>
        </el-col>

        <el-col :span="12">
          <div class="detail-item">
            <label>交易状态</label>

            <el-tag
              :type="statusTag(detail.trStatus)"
              size="small"
            >
              {{ statusText(detail.trStatus) }}
            </el-tag>

          </div>
        </el-col>

      </el-row>
    </el-card>

    <!-- 客户信息 -->
    <el-card shadow="hover" class="detail-card">
      <div slot="header">
        <span>客户信息</span>
      </div>

      <el-row :gutter="20">

        <el-col :span="12">
          <div class="detail-item">
            <label>姓名</label>
            <span>{{ detail.custName }}</span>
          </div>
        </el-col>

        <el-col :span="12">
          <div class="detail-item">
            <label>邮箱</label>
            <span>{{ detail.ciEmail }}</span>
          </div>
        </el-col>

        <el-col :span="12">
          <div class="detail-item">
            <label>电话</label>
            <span>{{ detail.ciTel }}</span>
          </div>
        </el-col>

        <el-col :span="12">
          <div class="detail-item">
            <label>IP地址</label>
            <span>{{ detail.custIp }}</span>
          </div>
        </el-col>

      </el-row>

    </el-card>

    <!-- 收货信息 -->
    <el-card shadow="hover" class="detail-card">
      <div slot="header">
        <span>收货信息</span>
      </div>

      <el-row :gutter="20">

        <el-col :span="12">
          <div class="detail-item">
            <label>收货人</label>
            <span>
              {{ detail.shipFirstName }}
              {{ detail.shipLastName }}
            </span>
          </div>
        </el-col>

        <el-col :span="12">
          <div class="detail-item">
            <label>联系电话</label>
            <span>{{ detail.shipPhone }}</span>
          </div>
        </el-col>

        <el-col :span="24">
          <div class="detail-item">
            <label>收货地址</label>
            <span>
              {{ detail.shipCountry }}
              {{ detail.shipState }}
              {{ detail.shipCity }}
              {{ detail.shipAddress }}
            </span>
          </div>
        </el-col>

      </el-row>

    </el-card>

    <!-- 风险信息 -->
    <el-card shadow="hover" class="detail-card">
      <div slot="header">
        <span>风险信息</span>
      </div>

      <el-row :gutter="20">

        <el-col :span="12">
          <div class="detail-item">
            <label>跨国交易</label>
            <span>
              {{ detail.flagkuatrade === 1 ? '是' : '否' }}
            </span>
          </div>
        </el-col>

        <el-col :span="12">
          <div class="detail-item">
            <label>高风险国家</label>
            <span>{{ detail.highriskcountry }}</span>
          </div>
        </el-col>

        <el-col :span="24">
          <div class="detail-item">
            <label>BIN国家/IP国家/账单国家</label>
            <span>
              {{ detail.binCountry }} /
              {{ detail.ipCountry }} /
              {{ detail.ciCountry }}
            </span>
          </div>
        </el-col>

      </el-row>

    </el-card>

  </div>
</template>


<script>
export default {
  data() {
    return {
      detail: {}
    }
  },
  props: {
    trNo: {
      type: String,
      default: ''
    }
  },
  watch: {
    trNo: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getDetail()
        }
      }
    }
  },

  methods: {
    statusText(status) {
      const map = {
        '-2': '失败',
        '-1': '待处理',
        '0': '处理中',
        '1': '成功'
      }

      return map[status] || '-'
    },

    statusTag(status) {
      const map = {
        '-2': 'danger',
        '-1': 'warning',
        '0': '',
        '1': 'success'
      }

      return map[status]
    },
    async getDetail() {

      const res = await this.$axios.get(
        '/api/unnormal/traderecord/current/info',
        {
          params: {
            trNo: this.trNo
          }
        }
      )

      this.detail = res.data.data
    }
  }
}
</script>


<style>

.order-detail {
  padding: 20px;
  background: #f5f7fa;
  min-height: 100vh;
}

.detail-card {
  margin-bottom: 20px;
  border-radius: 10px;
}

.detail-item {
  display: flex;
  margin-bottom: 18px;
  line-height: 24px;
}

.detail-item label {
  width: 140px;
  color: #909399;
  flex-shrink: 0;
}

.detail-item span {
  color: #303133;
  word-break: break-all;
}

::v-deep .el-card__header {
  font-weight: 600;
  font-size: 15px;
}

</style>



// WEBPACK FOOTER //
// src/view/merTradeMgr/TradeDetail.vue